import { render, staticRenderFns } from "./SchoolBus.vue?vue&type=template&id=548089c6&scoped=true&"
import script from "./SchoolBus.vue?vue&type=script&lang=js&"
export * from "./SchoolBus.vue?vue&type=script&lang=js&"
import style0 from "./SchoolBus.vue?vue&type=style&index=0&id=548089c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548089c6",
  null
  
)

export default component.exports